import React from "react";
import Slider from "react-slick";
// import App1 from "../images/ottplay.png";
import App2 from "../images/new_Jiohotstar.jpeg";
import App3 from "../images/new_Sonyliv.jpeg";
import App5 from "../images/new_Chaupal.jpeg";
import App6 from "../images/new_fancode.jpeg";
import App7 from "../images/new_stage.jpeg";
import App21 from "../images/Shortfundly.png";

import App20 from "../images/new_discovery.jpeg";
import App9 from "../images/RUnn.png";

import App10 from "../images/new_Sheemaro.webp";
import App11 from "../images/ShemarooBhakti.png";
import App12 from "../images/ShemarooGujarati.png";
import App13 from "../images/hubhopper.png";
import App14 from "../images/friday.png";
import App15 from "../images/Gurjari.png";

export const Ottslider = () => {
  var settings2 = {
    dots: false,
    navigation: true,
    loop: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: false,
    speed: 300,
    autoplaySpeed: 3000,
    cssEase: "linear",
  };
  return (
    <>
      <div className="ottslider">
        <Slider {...settings2}>
          <div>
            <div className="ottimg">
              <img src={App2} alt="Sony Live" />
            </div>
          </div>
          <div>
            <div className="ottimg">
              <img src={App3} alt="Disney Hotstar" />
            </div>
          </div>
          <div>
            <div className="ottimg">
              <img src={App5} alt="Amazon Prime" />
            </div>
          </div>
          <div>
            <div className="ottimg">
              <img src={App6} alt="Amazon Prime" />
            </div>
          </div>
          <div>
            <div className="ottimg">
              <img src={App7} alt="Amazon Prime" />
            </div>
          </div>
          <div>
            <div className="ottimg">
              <img src={App21} alt="Amazon Prime" />
            </div>
          </div>
          <div>
            <div className="ottimg">
              <img src={App9} alt="Amazon Prime" />
            </div>
          </div>
          <div>
            <div className="ottimg">
              <img src={App20} alt="Amazon Prime" />
            </div>
          </div>
          <div>
            <div className="ottimg">
              <img src={App10} alt="Amazon Prime" />
            </div>
          </div>
          <div>
            <div className="ottimg">
              <img src={App11} alt="Amazon Prime" />
            </div>
          </div>
          <div>
            <div className="ottimg">
              <img src={App12} alt="Amazon Prime" />
            </div>
          </div>
          <div>
            <div className="ottimg">
              <img src={App13} alt="Amazon Prime" />
            </div>
          </div>
          <div>
            <div className="ottimg">
              <img src={App14} alt="Amazon Prime" />
            </div>
          </div>
          <div>
            <div className="ottimg">
              <img src={App15} alt="Amazon Prime" />
            </div>
          </div>
        </Slider>
      </div>
    </>
  );
};
